<template>
  <PopperPreviewer
    :open="open"
    v-bind="popperProps"
  >
    <!--
      tried intercepting this slot-node through a render function in order to
      alter it to apply display none to its root node in case isOpen was true
      however, failed to do that and since v-show can't be applied to slot
      elements, ended up wrapping it in an extra dom-node

      TODO: if its possible achieve the functionality described above, do and
      remove this extra dom-node

      One more thing:
      The use case for which the v-bind="$attrs" below was added was so that a class
      from the outside to style the underlying Surface (content of the Popover)
      because the Surface can be considered the root node of this component even though
      it physically cannot be that in the dom-structure

      Unfortunately $attrs does not contain the 'style' and 'class' html attributes
      they are treated as special attributes by Vue, this is however to be removed in 3.0
      https://github.com/vuejs/vue/issues/6144#issuecomment-472670905

      The only solution to 'forward' the style or class attribute to an element of choice
      from the component implementation would be to use a custom prop, however I'm going
      to leave this out for now
    -->
    <Surface
      ref="surface"
      class="surface"
      v-show="open"
      v-bind="$attrs"
    >
      <slot />
    </Surface>

    <slot
      slot="reference"
      name="reference"
    />
  </PopperPreviewer>
</template>

<script>

import PopperPreviewer from './PopperPreviewer'
import Surface from '@converdy/atoms/Surface'

export default {
  name: 'PopoverPreviewer',

  components: {
    PopperPreviewer,
    Surface
  },

  props: {
    open: { type: Boolean },
    placement: {},
    modifiers: {}, 
    strategy: {},
    onFirstUpdate: {}
  },

  methods: {
    handleWindowClick (e) {
      const targetIsChildOfSurface = this.$refs.surface.$el.contains(e.target)

      if (!targetIsChildOfSurface) {
        this.$emit('close', e)
      }
    },

    manageCloseListeners (open) {

      if (open) {
        /*
         * defer the attachment of the window click listener to after
         * any scheduled operations in the current callstack for the
         * use-case that the event that triggered the 'open' prop to
         * change was a click
         *
         * the reason for this is that, in the event that a click triggers
         * the 'open' prop to change the event listener on the window would
         * be attached before the event propagated to the the window due to
         * Vue's synchronous reactivity system
         */
        setTimeout(
          () => {
            window.addEventListener('click', this.handleWindowClick)
          }
        )
      } else {
        window.removeEventListener('click', this.handleWindowClick)
      }
    }
  },

  mounted () {
    this.manageCloseListeners(this.open)
  },

  destroyed () {
    window.removeEventListener('click', this.handleWindowClick)
  },

  watch: {
    open (open) {
      this.manageCloseListeners(open)
    }
  },

  computed: {
    popperProps () {
      return {
        placement: this.placement,
        modifiers: this.modifiers,
        strategy: this.strategy,
        onFirstUpdate: this.onFirstUpdate
      }
    }
  }
}

</script>

<style scoped>

.surface {
  z-index: 1;
  -webkit-box-shadow: 1px 2px 4px 1px rgba(0,0,0,0.1);
  -moz-box-shadow: 1px 2px 4px 1px rgba(0,0,0,0.1);
  box-shadow: 1px 2px 4px 1px rgba(0,0,0,0.1);
}

</style>
